import { mapEnumToOptions } from '@abp/ng.core';

export enum InvoiceStatus {
  InProgress = 0,
  Accepted = 1,
  Rejected = 2,
  Approved = 3,
  PaymentStatus = 4,
}

export const invoiceStatusOptions = mapEnumToOptions(InvoiceStatus);
